import { render, staticRenderFns } from "./selectCreateWay.vue?vue&type=template&id=2ee7da44&scoped=true"
import script from "./selectCreateWay.vue?vue&type=script&lang=js"
export * from "./selectCreateWay.vue?vue&type=script&lang=js"
import style0 from "./selectCreateWay.vue?vue&type=style&index=0&id=2ee7da44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee7da44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ee7da44')) {
      api.createRecord('2ee7da44', component.options)
    } else {
      api.reload('2ee7da44', component.options)
    }
    module.hot.accept("./selectCreateWay.vue?vue&type=template&id=2ee7da44&scoped=true", function () {
      api.rerender('2ee7da44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newLabelManagement/labelManagement/components/selectCreateWay.vue"
export default component.exports